export default "__VITE_ASSET__BiClbGMl__"